/**
 * Smart Prefetching Component for AllTuc
 * Prefetches heavy routes based on user behavior and patterns
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SmartPrefetcher: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Prefetch based on current page patterns
    const prefetchRoutes = () => {
      try {
        // Prefetch admin routes if user has admin tendencies
        if (location.pathname.startsWith('/admin')) {
          import('../features/admin/AdminOperationsScreen');
        }

        // Prefetch checkout routes when in cart
        if (location.pathname === '/cart') {
          import('../features/cart/PaymentScreen');
          import('../features/cart/CheckoutReviewScreen');
        }

        // Note: ProductDetailScreen is already statically imported in index.tsx
        // No need for dynamic import here - it's already available

        // Prefetch auth routes (small files)
        if (!location.pathname.startsWith('/auth')) {
          import('../features/auth/ForgotPasswordScreen');
          import('../features/auth/RegisterSuccessScreen');
        }
      } catch (error) {
        console.warn('Prefetch error:', error);
      }
    };

    // Prefetch after initial render (delay to not block initial load)
    const timeoutId = setTimeout(prefetchRoutes, 2000);
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  return null;
};

export default SmartPrefetcher;